// extracted by mini-css-extract-plugin
export default {"paper":"dashboard-section_paper__fX4Ql","mainSection":"dashboard-section_mainSection__Xnkrc","chip":"dashboard-section_chip__yBGzA","list":"dashboard-section_list__buWE8"};